import Base from './Base';
import LocationModel from './Location';
import ChamberOfCommerceModel from './ChamberOfCommerce';

export default class CompanyModel extends Base  {
	public id: number;
	public _company_id: number;
	public name: string;
	public full_address: string;
	public address: string;
	public house_no: number;
	public house_no_ext: string;
	public zipcode: string;
	public residence: string;
	public country: string;
	public phone1: string;
	public phone2: string;
	public fax: string;
	public email1: string;
	public email2: string;
	public coc: string;
	public vat_no: string;
	public image: string;
	public COCCheck: boolean;
	private _type: string;
	private _user_type: string;
	private _pivot: object;
	public credits: number;
	private _created_at: Date;
	private _updated_at: Date;
	private _location: LocationModel;
	private _chamberofcommerce: ChamberOfCommerceModel;

	constructor(data?: object) {
		super(null);
		this.name = "";
		this.full_address = "";
		this.address = "";
		this.house_no = 0;
		this.house_no_ext = "";
		this.zipcode = "";
		this.residence = "";
		this.country = "";
		this.phone1 = "";
		this.phone2 = "";
		this.fax = "";
		this.email1 = "";
		this.email2 = "";
		this.coc = "";
		this.vat_no = "";
		this.image = "";
		this._type = "";
		this._user_type = "";
		this.credits = 0;
		this._company_id = 0;
		this.COCCheck = false;
		this._created_at = new Date();
		this._updated_at = new Date();
		this._chamberofcommerce = new ChamberOfCommerceModel();
		
		this.addData(data);
	}

	set company_id(value) {
		this._company_id = value;
	}	

	get company_id() {
		return this._company_id;
	}

	set chamberofcommerce(value) {
		const cocModel = new ChamberOfCommerceModel(value);
		this._chamberofcommerce = cocModel;
	}	

	get chamberofcommerce() {
		return this._chamberofcommerce;
	}

	set location(value) {
		const locationModel = new LocationModel(value);
		this._location = locationModel;
	}	

	get location() {
		if(!this._location) {
			const locationModel = new LocationModel();
			this._location = locationModel;
		}
		return this._location;
	}

	
	get type() {
		return this._type;
	}
	set type(val) {
		this._type = val;
	}
	get created_at() {
		return this._created_at;
	}
	set created_at(val) {
		this._created_at = val;
	}
	set pivot(val) {
		this._pivot = val;
		this._user_type = val.user_type;
	}
	get userType() {
		return this._user_type;
	}
	get websiteUserType() {
		let retVal = 'Medewerker';
		switch(this._user_type) {
			case 'OWNER':
				retVal = 'Eigenaar';
				break;
		}
		return retVal;
	}		
			
	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new CompanyModel();
	}


	
}